<template>
  <!--横向列表区块 开始-->
  <div class="application clearfix">
    <div class="more-product clearfix">
      <template v-for="(item,ind) in listData">
        <div class="product"
             :key="ind"
             v-if="ind<10"
             @click="$emit('emitHandleDetail',item)"
             @contextmenu="$emit('emitContextMenuItem',ind)"
             @touchstart="touchstarts(ind)"
             @touchmove="touchmoves()"
             @touchend="touchends()">
          <a href="javascript:;">
            <div class="img-box">
              <ZImage :value="item.pictures[0]?item.pictures[0]:''"
                      :error-src="require('../../assets/image/images/default_media.png')" />
            </div>
            <div class="product-name">
              {{item.others[0].standardData?item.others[0].standardData:''}}
            </div>
          </a>
        </div>
      </template>
    </div>
  </div>

  <!--横向列表区块 结束-->
</template>
<script>
import ZImage from "../ZImage.vue"
export default {
  name: 'enterpris',
  components: {
    ZImage
  },
  props: {
    listData: {
      type: Array
    }
  },
  data () {
    return {
      timeOutEvent: 0
    }
  },
  methods: {
    touchstarts (ind) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ind);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    }
  }
}

</script>
<style scoped>
/*小区块样式 开始*/
.more-product {
  -webkit-flex-flow: row wrap;
  flex-flow: row wrap;
  height: 326px;
  overflow: hidden;
  padding: 18px 20px;
}
.more-product .product {
  box-sizing: border-box;
  border: 1px solid #dddddd;
  width: calc(20% - 8px);
  margin: 0 10px 10px 0;
  float: left;
  overflow: hidden;
}
.more-product .product:nth-child(5n) {
  margin-right: 0;
}
.more-product .img-box {
  margin: 10px 0;
  height: 100px;
  text-align: center;
}
.more-product .img-box img {
  display: block;
  width: 64px;
  height: 64px;
  margin: 0 auto;
}
.more-product .product-name {
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  border-top: 1px dashed #dddddd;
  line-height: 34px;
  color: #666666;
  text-align: center;
  font-size: 14px;
  height: 34px;
}
.more-product .product:hover {
  transition: 0.5s;
  -moz-box-shadow: 3px 3px 14px #dddddd;
  -webkit-box-shadow: 3px 3px 14px #dddddd;
  box-shadow: 3px 3px 14px #dddddd;
}
@media screen   and (max-width: 768px) {
  .more-product {
    height: auto;
  }
  .more-product .product {
    width: calc(50% - 4px);
    margin-right: 0px;
  }
  .more-product .product:nth-child(odd) {
    margin-right: 8px;
  }
}
/*小区块样式 结束*/
</style>>



// WEBPACK FOOTER //
// src/components/floorBlock/small_block.vue